module.exports = __webpack_public_path__ + "img/Scheduler.04c01ed1.svg";